<template>
  <v-main v-if="lvl == 1">
    <v-container fluid class="text-right">
      <v-card class="pa-3 ma-2 text-left" outlined>
        <v-row dense>
          <v-col cols="12" >
            팀 추가
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="9" >
            <v-text-field
              dense
              v-model="new_team.name"
              class="center-input"
              label="팀 명"
              required
              v-on:change="changeTeamName">
            </v-text-field>
            <v-text-field
              dense
              v-model="new_team.managers"
              class="center-input"
              label="팀 관리자"
              persistent-hint
              hint="이메일 입력, 콤마(,) 로 다수 팀 관리자 입력 가능"
              required
              v-on:change="changeTeamManagers">
            </v-text-field>
            <v-text-field
              dense
              v-model="new_team.members"
              class="center-input"
              label="팀 원"
              persistent-hint
              hint="이메일 입력, 콤마(,) 로 다수 팀 관리자 입력 가능"
              required
              v-on:change="changeTeamMembers">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn color="#FBDE44FF" block class="black--text" @click="submit_create_team">
              팀 생성
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="pa-3 ma-2 text-left" outlined>
        <v-row dense>
          <v-col cols="12" >
            팀 목록
          </v-col>
        </v-row>
        <v-row v-for="each of team_list" :key="each._id">
          <v-col cols="12">
            <v-card class="pa-3 ma-2 text-left" outlined>
              <v-row dense>
                <v-col cols="4">
                  {{ each.name }}
                </v-col>
                <v-col cols="4">
                  {{ each.managers }}
                </v-col>
                <v-col cols="4">
                  {{ each.members }}
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import { mapGetters } from 'vuex'

import api_conf from '../../config/config.json'

export default {
  props: {
    msg: String
  },
  data: () => {
    return {
      new_team : {
        name: "",
        managers: [],
        members: [],
      },
      team_list: [],
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
      lvl: "lvl",
    })
  },
  created: async function() {
    // this.loading = true;
  },
  mounted: async function() {
    if ( firebase.auth().currentUser ) {
      // this.arrange()

      // this.loading = false;
      this.get_team_list();
    }
  },
  watch: {
    // dialog (val) {
    //   val || this.close()
    // },
  },
  methods: {
    changeTeamName: async function(v) {
      this.new_team.name = v;
    },
    changeTeamManagers: async function (v) {
      this.new_team.managers = v.split(',');
    },
    changeTeamMembers: async function (v) {
      this.new_team.members = v.split(',');
    },
    submit_create_team: async function() {
      const id_token = await firebase.auth().currentUser.getIdToken();
      await axios.post(
        api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/team/', {
          ...this.new_team,
          email: this.user.data.email
      }, {
        headers: {'id_token': id_token},
      });
      this.get_team_list();
    },
    get_team_list: async function() {
      const id_token = await firebase.auth().currentUser.getIdToken();
      const team_list = await axios.get(
        api_conf.protocol+'://'+api_conf.server+':'+api_conf.port+'/team/', {
        params: { email: this.user.data.email },
        headers: {'id_token': id_token},
      });
      console.log(team_list);
      this.team_list = team_list.data;
    }
  }
}
</script>

<style scoped>

</style>
